import Vue from 'vue';
import store from 'store/store.js'
import Vuex from 'vuex';
import axios from 'axios'

import Component from 'vue-class-component';

@Component
export default class NotFound extends Vue {

    constructor() {
        super();
    }

    render(h) {
        return (
            <div>
                404 Not Found
                <router-link to="/auth">На авторизацию</router-link>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/NotFound.js